import profileHeader from 'Profile/mixin/profileHeader';
import router from 'Profile/js/router';
import store from 'Site/js/store';
import Vue from 'vue';
import VueRouter from 'vue-router';

export default function () {
    if (!store.state.config.data) {
        return;
    }

    if (document.querySelector('.profile-body')) {
        Vue.use(VueRouter);

        new Vue({ /* eslint no-new: 0 */
            el: '#profile-vue',
            name: 'ProfilePage',
            methods: {
                highlight() {
                    let $element = null;
                    switch (window.location.hash) {
                        case '#description':
                            $element = document.querySelector('.profile-description');
                            break;
                        case '#interests':
                            $element = document.querySelector('.profile-interests');
                            break;
                        case '#seeking':
                            $element = document.querySelector('.profile-seeking');
                            break;
                        default:
                            break;
                    }

                    if ($element) {
                        $element.classList.add('highlight');
                        $element.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                    }
                }
            },
            mounted() {
                setTimeout(this.highlight, 1000);
                this.$nextTick(() => {
                    if (window.location.hash === '#avatar') {
                        this.showAvatarModal = true;
                    }
                });
            },
            data() {
                return {
                    editMode: store.state.config.data.editMode
                };
            },
            mixins: [profileHeader],
            router,
            store
        });
    }
}
